export const FIELD_NAMES = {
  ADDRESS_1: 'address1',
  ADDRESS_2: 'address2',
  CITY: 'city',
  STATE: 'state',
  POSTAL_CODE: 'postalCode'
};
